// src/components/FilterControls.js
import React from 'react';
import '../css/FilterControls.css';

export default function FilterControls({
  query,
  onQueryChange,
  phaseFilters,
  onTogglePhase,
  ltsOnly,
  onToggleLts
}) {
  return (
    <div className="filters-panel">
      <input
        type="text"
        placeholder="Search features…"
        value={query}
        onChange={e => onQueryChange(e.target.value)}
        className="search-input"
      />
      {['Incubator','Preview','Final'].map(phase => (
        <label key={phase} className="filter-label">
          <input
            type="checkbox"
            checked={phaseFilters[phase]}
            onChange={() => onTogglePhase(phase)}
          />{' '}
          {phase}
        </label>
      ))}
      <label className="filter-label lts-label">
        <input
          type="checkbox"
          checked={ltsOnly}
          onChange={onToggleLts}
        />{' '}
        LTS only
      </label>
    </div>
  );
}
